export default __webpack_public_path__ + "static/media/gradient.ba03f56a.png";